import './scripts/modalFilms';
import './scripts/team-modal';
import './scripts/switchTheme';
import './scripts/btnToTop';

import { loadWatchedFilms, setupLIbraryBtns } from './scripts/mylibrary';

loadWatchedFilms();

setupLIbraryBtns();
